<script>
// Components
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config.json";
import UserProfile from "@/router/views/users/user-profile"
import ThreadAiView from "@/router/views/system/thread-ai-view"

// Helpers
import {authComputed} from "@/state/helpers";
import FirestoreUtils from '@/helpers/firestore';
import DateUtils from '@/helpers/date';
import UserUtils from '@/helpers/users';
import HelperUtils from '@/helpers/helper';
import Storage from "@/helpers/storage";
import { Role, getRole } from '@/helpers/role';

// Services
import AIGeneratorService from "@/services/AIGeneratorService";
import MarketingDataService from "@/services/MarketingDataService";
import UsersDataService from "@/services/UsersDataService"

// External Components
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

// Lib
import isEmpty from "is-empty";

const ads = {};
const marketing = {};
const organic = {};
const adsData1 = {};
const adsData2 = {};

export default {
  name: "generator",
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Generator Controller",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    DatePicker,
    VueTabs,
    VTab,
    UserProfile,
    ThreadAiView,
    CoolLightBox,
  },

  computed: {
    ...authComputed,

    getUserRole() {
      return getRole(this.getRole);
    }
  },

  methods: {
    ...UserUtils,
    ...DateUtils,
    ...HelperUtils,

    handlePageChange(value) {
      this.page = value;
      if (this.generatorSearch === 'filters') {
        this.loadThreads();
      }
      else if (this.generatorSearch === 'search')
        this.processSearch(false);
    },

    handleAutoPageChange(value) {
      this.pageAuto = value;
      this.loadThreadsAuto();
    },

    handleDisplayChange() {
      this.loadThreads();
      this.loadThreadsAuto();
    },

    handleDateChange() {
      let now = new this.$moment();
      switch(this.filters.dates.selected) {
        case "always":
          this.filters.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filters.fromDate = now.format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filters.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filters.toDate = this.filters.fromDate;
          break;
        case "week":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filters.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filters.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filters.fromDate = null;
          this.filters.toDate = null;
          break;
      }
    },

    handleAutoDateChange() {
      let now = new this.$moment();
      switch(this.filtersAuto.dates.selected) {
        case "always":
          this.filtersAuto.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filtersAuto.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filtersAuto.fromDate = now.format('YYYY-MM-DD');
          this.filtersAuto.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersAuto.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersAuto.toDate = this.filtersAuto.fromDate;
          break;
        case "week":
          this.filtersAuto.toDate = now.format('YYYY-MM-DD');
          this.filtersAuto.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersAuto.toDate = now.format('YYYY-MM-DD');
          this.filtersAuto.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersAuto.toDate = now.format('YYYY-MM-DD');
          this.filtersAuto.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersAuto.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersAuto.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersAuto.toDate = now.format('YYYY-MM-DD');
          this.filtersAuto.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersAuto.toDate = now.format('YYYY-MM-DD');
          this.filtersAuto.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersAuto.fromDate = null;
          this.filtersAuto.toDate = null;
          break;
      }
    },

    getRequestParams() {
      const params = {};

      params["page"] = this.page - 1;
      params["size"] = this.pageSizes.selected;
      params["isAdmin"] = this.isAdmin;

      if (this.isAdmin) {
        if (this.filters.dates.selected === 'custom' && this.filters.dates.dateRange !== null) {
          this.filters.fromDate = this.$moment(this.filters.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
          this.filters.toDate = this.$moment(this.filters.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
        } else if (this.filters.fromDate === null)
          this.handleDateChange();

        if (this.filters.toDate !== null)
          params['toDate'] = this.filters.toDate;

        if (this.filters.fromDate !== null)
          params['fromDate'] = this.filters.fromDate;

        params['gender'] = this.filters.genders.selected;
        params['status'] = this.filters.status.selected;
        params['iceBreaker'] = this.filters.iceBreaker.selected;
        params['threadType'] = this.filters.threadType.selected;
        params['organic'] = this.filters.organic.selected;
        params['countries'] = this.filters.countries.selected;
        if (this.filters.adsData3.selected !== 'all') {
          params['ads'] = this.filters.adsData3.selected;
        } else if (this.filters.adsData2.selected !== 'all') {
          params['ads'] = this.filters.adsData2.selected;
        } else if (this.filters.adsData1.selected !== 'all') {
          params['ads'] = this.filters.adsData1.selected;
        } else {
          params['ads'] = this.filters.ads.selected;
        }

        if (this.$store.state.layout.timezone === 'utc') {
          params['tz'] = this.$moment.tz.guess();
        }
      }

      return params;
    },

    getAutoRequestParams() {
      const params = {};

      params["page"] = this.pageAuto - 1;
      params["size"] = this.pageSizes.selected;
      params["isAdmin"] = this.isAdmin;

      if (this.isAdmin) {
        if (this.filtersAuto.dates.selected === 'custom' && this.filtersAuto.dates.dateRange !== null) {
          this.filtersAuto.fromDate = this.$moment(this.filtersAuto.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
          this.filtersAuto.toDate = this.$moment(this.filtersAuto.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
        } else if (this.filtersAuto.fromDate === null)
          this.handleAutoDateChange();

        if (this.filtersAuto.toDate !== null)
          params['toDate'] = this.filtersAuto.toDate;

        if (this.filtersAuto.fromDate !== null)
          params['fromDate'] = this.filtersAuto.fromDate;

        params['gender'] = this.filtersAuto.genders.selected;
        params['organic'] = this.filtersAuto.organic.selected;
        params['countries'] = this.filtersAuto.countries.selected;
        params['status'] = this.filtersAuto.status.selected;

        if (this.filtersAuto.adsData3.selected !== 'all') {
          params['ads'] = this.filtersAuto.adsData3.selected;
        } else if (this.filtersAuto.adsData2.selected !== 'all') {
          params['ads'] = this.filtersAuto.adsData2.selected;
        } else if (this.filtersAuto.adsData1.selected !== 'all') {
          params['ads'] = this.filtersAuto.adsData1.selected;
        } else {
          params['ads'] = this.filtersAuto.ads.selected;
        }

        if (this.$store.state.layout.timezone === 'utc') {
          params['tz'] = this.$moment.tz.guess();
        }
      }

      return params;
    },

    loadStats() {
      const params = this.getRequestParams();
      AIGeneratorService
          .getStats(params)
          .then(response => {

            const {total, types, operators, historyGraph, operatorsGraph, operatorsMessage} = response.data;
            this.stats.replied = total.replied;
            this.stats.waiting = total.waiting;
            this.stats.closed = total.closed;
            this.stats.temporary = total.temporary;
            this.stats.answers = total.answers;
            this.stats.terminated = total.terminated;
            this.stats.messages = total.messages;
            this.stats.threads_replies = total.threads_replies;
            this.stats.avg_message = total.avg_message;
            this.stats.avg_replies = total.avg_replies;

            if (this.isAdmin) {
              this.typesGraph.series = types.series;
              this.typesGraph.chartOptions = {
                ...this.typesGraph.chartOptions, ...{
                  labels: types.labels
                }
              };

              this.operatorsGraph.series = operators.series;
              this.operatorsGraph.chartOptions = {
                ...this.operatorsGraph.chartOptions, ...{
                  labels: operators.labels
                }
              };

              const opMessagesSeries = [];
              for (let i = 0; i< operatorsMessage.series.length; i++) {
                opMessagesSeries.push({
                  name: operatorsMessage.series[i].name,
                  type: "bar",
                  data: operatorsMessage.series[i].data
                });
              }
              this.$refs.generatorOperatorsMessageChart.updateSeries(opMessagesSeries);
              this.$refs.generatorOperatorsMessageChart.updateOptions({
                xaxis: {
                  categories: operatorsMessage.labels
                }
              });

              const opSeries = [];
              for (let [key, value] of Object.entries(operatorsGraph)) {
                opSeries.push({
                  name: key,
                  type: "bar",
                  data: value
                });
              }

              this.$refs.generatorOperatorsHistoryGraph.updateSeries(opSeries);

              this.$refs.generatorMessagesHistoryGraph.updateSeries([{
                name: "Messages Sent",
                type: 'area',
                data: historyGraph.messages
              }, {
                name: "Replies Generated",
                type: 'bar',
                data: historyGraph.answers
              }]);

              this.$refs.generatorThreadsAvgHistoryGraph.updateSeries([{
                name: "AVG Threads",
                type: 'line',
                data: historyGraph.avg_threads_users
              }
              ]);

              this.$refs.generatorThreadsTypesAvgHistoryGraph.updateSeries([{
                name: "AVG Default",
                type: 'line',
                data: historyGraph.avg_threads_D_users
              }, {
                name: "AVG Default Subscribed",
                type: 'line',
                data: historyGraph.avg_threads_S_users
              }, {
                name: "AVG Matches",
                type: 'line',
                data: historyGraph.avg_threads_M_users
              }, {
                name: "AVG IceBreakers",
                type: 'line',
                data: historyGraph.avg_threads_I_users
              }]);

              this.$refs.generatorThreadsRepliesHistoryGraph.updateSeries([{
                name: "Threads Replied",
                type: 'bar',
                data: historyGraph.threads_replies
              }, {
                name: "AVG Replies",
                type: 'line',
                data: historyGraph.avg_replies
              }]);

              this.$refs.generatorHistoryChart.updateSeries([{
                name: "Waiting",
                type: 'bar',
                data: historyGraph.waiting
              }, {
                name: "Replied",
                type: 'bar',
                data: historyGraph.replied
              }, {
                name: "Closed",
                type: 'bar',
                data: historyGraph.closed
              }, {
                name: "Temporary",
                type: 'bar',
                data: historyGraph.temporary
              }]);
            }
          })
          .catch(error => {
            window.console.error(error);
          });
    },

    loadAutoStats() {
      const params = this.getAutoRequestParams();
      AIGeneratorService
          .getAutoStats(params)
          .then(response => {

            const {total, closedReasonsGraph, statusGraph, historyGraph} = response.data;

            this.statsAuto.total = total.total;
            this.statsAuto.processed = total.processed;
            this.statsAuto.processed_ratio = total.processed_ratio;
            this.statsAuto.avg_answers = total.avg_answers;
            this.statsAuto.avg_accept_delay = total.avg_accept_delay;
            this.statsAuto.accepted = total.accepted;
            this.statsAuto.accepted_ratio = total.accepted_ratio;
            this.statsAuto.expired = total.expired;
            this.statsAuto.expired_ratio = total.expired_ratio;
            this.statsAuto.replied = total.replied;
            this.statsAuto.replied_ratio = total.replied_ratio;
            this.statsAuto.closed = total.closed;

            if (this.isAdmin) {
              this.closedReasonsGraph.series = closedReasonsGraph.series;
              this.closedReasonsGraph.chartOptions = {
                ...this.closedReasonsGraph.chartOptions, ...{
                  labels: closedReasonsGraph.labels,
                  colors: closedReasonsGraph.colors
                }
              };

              this.autoStatusGraph.series = statusGraph.series;
              this.autoStatusGraph.chartOptions = {
                ...this.autoStatusGraph.chartOptions, ...{
                  labels: statusGraph.labels,
                  colors: statusGraph.colors
                }
              };

              this.$refs.generatorAutoHistoryStatusChart.updateSeries([{
                  name: "Not Accepted",
                  type: 'bar',
                  data: historyGraph.auto_expired
                }, {
                  name: "IA Connected",
                  type: 'bar',
                  data: historyGraph.auto_ia
                }, {
                  name: "Late Replies",
                  type: 'bar',
                  data: historyGraph.auto_replied
                }, {
                  name: "No replies",
                  type: 'bar',
                  data: historyGraph.auto_accepted
              }]);
            }
          })
          .catch(error => {
            window.console.error(error);
          });
    },

    loadThreads() {
      this.loaded = true;
      this.isLoading = true;
      const params = this.getRequestParams();
      this.generatorSearch = 'filters';
      AIGeneratorService
          .getUsersThreads(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.threads = items;
            this.count = totalItems
            this.getMediaThumb();
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("ai_stats.errorGeneratorNoResult"));
          })
          .finally(() => {
            this.isLoading = false;
          });
    },

    loadThreadsAuto() {
      this.loadedAuto = true;
      this.isLoadingAuto = true;
      const params = this.getAutoRequestParams();
      AIGeneratorService
          .getAutoThreads(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.threadsAuto = items;
            this.countAuto = totalItems
            this.getMediaThumbAuto();
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("ai_stats.errorGeneratorNoResult"));
          })
          .finally(() => {
            this.isLoadingAuto = false;
          });
    },

    resetData() {
      this.threads = [];
      this.stats = {
        waiting: '-',
        replied: '-',
        temporary: '-',
        closed: '-',
        threads_replies: '-',
        terminated: '-',
        avg_message: '-',
        avg_replies: '-',
        messages: '-',
        answers: '-',
      };
    },

    resetAutoData() {
      this.threadsAuto = [];

      this.statsAuto = {
        total: '-',
        processed: '-',
        processed_ratio: '-',
        avg_answers: '-',
        avg_accept_delay: '-',
        accepted: '-',
        accepted_ratio: '-',
        expired: '-',
        expired_ratio: '-',
        replied: '-',
        replied_ratio: '-',
        closed: '-',
      };
    },

    processFilters() {
      this.resetData();
      this.loadThreads();
      this.loadStats();
    },

    processAutoFilters() {
      this.resetAutoData();
      this.loadThreadsAuto();
      this.loadAutoStats();
    },

    getFilters() {
      MarketingDataService.getAdsNonOrganicFilters()
          .then(response => {
            marketing.ads = response.data.filters.ads;
            response.data.filters.ads.forEach(ad => {
              this.filters.ads.options.push(ad);
              this.filtersAuto.ads.options.push(ad);
            });
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("marketing.getAdsNonOrganicFilters"));
          });
    },

    processSearch(resetPage) {
      if (isEmpty(this.filters.searchType)) {
        this.$toast.error(this.$t("generator.error_searchType"));
        return;
      }

      if (isEmpty(this.filters.searchData)) {
        this.$toast.error(this.$t("generator.error_searchData"));
        return;
      }

      this.generatorSearch = 'search';
      if (resetPage) {
        this.page = 1;
      }

      this.isLoading = true;
      const params = {
        type: this.filters.searchType.selected,
        data: this.filters.searchData,
        page: this.page - 1,
        size: this.pageSizes.selected,
      };

      AIGeneratorService
          .search(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.threads = items;
            this.count = totalItems;
            this.isLoading = false;
            this.getMediaThumb();
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("generator.errorGeneratorNoResult"));
            this.isLoading = false;
          });
    },

    getMediaThumb() {
      if (this.threads.length > 0) {
        this.threads.forEach(row => {
          if (row.photo && row.photo.length > 0)
            Storage.getUserMedia(row.userId, row.photo, 'ai-generator-user-' + row.threadId);

          if (row.senderPhoto && row.senderPhoto.length > 0)
            Storage.getUserMedia(row.senderId, row.senderPhoto, 'ai-generator-user-' + row.threadId + "-sender");

        });
      }
    },

    getMediaThumbAuto() {
      if (this.threadsAuto.length > 0) {
        this.threadsAuto.forEach(row => {
          if (row.photo && row.photo.length > 0)
            Storage.getUserMedia(row.userId, row.photo, 'ai-generator-user-' + row.chatRoomId);

          if (row.senderPhoto && row.senderPhoto.length > 0)
            Storage.getUserMedia(row.senderId, row.senderPhoto, 'ai-generator-user-' + row.chatRoomId + "-sender");

        });
      }
    },

    _isEmpty(val) {
      return isEmpty(val);
    },

    searchUser(userId) {
      this.filters.searchType.selected = 'userId';
      this.filters.searchData = userId;
      this.processSearch(true);
    },

    showThread(thread) {
      this.threadActive = thread;
      this.$bvModal.show("threads-modal");
    },

    updateThreadStatus(thread) {
      if (!isEmpty(thread.all)) {
        for (const elt of this.threads) {
          if (elt.userId === thread.userId) {
            elt.status = 'D';
          }
        }
      }
      else {
        const threadObj = this.threads.find(elt => elt.chatRoomId === thread.chatRoomId);
        if (!isEmpty(threadObj)) {
          const oldStatus = threadObj.status;
          switch (oldStatus) {
            case "W":
              this.stats.waiting--;
              break;
            case "T":
              this.stats.temporary--;
              break;
          }

          switch (thread.status) {
            case "W":
              this.stats.waiting++;
              break;
            case "T":
              this.stats.temporary++;
              break;
            case "R":
              this.stats.replied++;
              break;
            case "D":
              this.stats.closed++;
              break;
          }

          threadObj.status = thread.status;
          if (thread.lastReplyAt !== threadObj.lastReplyAt) {
            threadObj.lastReplyAt = thread.lastReplyAt;
            threadObj.actionDate = thread.actionDate;
          }
        }
      }
    },

    showContextMenu(event, user) {
      this.$refs.generatorContextMenu.showMenu(event, user)
    },

    processContextMenu(event) {
      const { item, option } = event;
      switch (option.value) {
        case "show_user":
          this.showUser(item.userId, 'user');
          break;
        case "show_member":
          this.showUser(item.senderId, 'sender');
          break;
        case "thread":
          this.showThread(item);
          break;
        case "search":
          this.searchUser(item.userId);
          break;
      }
    },

    /* Assistants */

    loadAssistants() {
      this.isLoadingAssistants = false;

      FirestoreUtils.loadCloseChatInstructions()
          .then((data) => {
            this.instructionsEndChat = data;
            this.newInstructionsEndChat = data.instructions;
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("aigenerator.loadCloseChatInstructions"));
          });

      FirestoreUtils.loadStartChatInstructions()
          .then((data) => {
            this.instructionsStartChat = data;
            this.newInstructionsStartChat = data.instructions;
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("aigenerator.loadStartChatInstructions"));
          });

      AIGeneratorService.getAssistants()
          .then(response => {
            const { items } = response.data;
            this.assistants = items;
            if (items.length > 0) {
              this.assistant = items[0];
              this.assistantInstructions = items[0].instructions;
              this.loadThreads();
            }
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("aigenerator.loadAssistants"));
            this.isLoading = false;
          });
    },

    updateStartChatInstructions() {
      if (isEmpty(this.newInstructionsStartChat) || this.newInstructionsStartChat.length < 20) {
        this.$toast.error("Instructions not valid !");
        return;
      }

      const h = this.$createElement;
      const messageVNode = h('div', {
        class:'text-center'
      }, [
        h('span', {
          class: "d-inline-block text-muted m-2",
          style: {
            verticalAlign: 'middle'
          },
          domProps: {
            innerHTML: `Confirm updating new START instructions ?`
          }
        })
      ]);

      this.$bvModal.msgBoxConfirm([messageVNode],  {
        title: this.$t('confirm_title'),
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: this.$t('confirm'),
        cancelTitle: this.$t('cancel'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
          .then(value => {
            if (value) {
              this.isUpdatingStartInstructions = true;
              FirestoreUtils.saveStartChatInstructions(this.newInstructionsStartChat)
                  .then(() => {
                    this.$toast.success("Start Chat Instructions UPDATED !");
                  })
                  .catch((error) => {
                    window.console.error(error);
                    this.$toast.error(error.message);
                  })
                  .finally(() => {
                    this.isUpdatingStartInstructions = false;
                  });
            }
          });
    },

    updateCloseChatInstructions() {
      if (isEmpty(this.newInstructionsEndChat) || this.newInstructionsEndChat.length < 20) {
        this.$toast.error("Instructions not valid !");
        return;
      }

      const h = this.$createElement;
      const messageVNode = h('div', {
        class:'text-center'
      }, [
        h('span', {
          class: "d-inline-block text-muted m-2",
          style: {
            verticalAlign: 'middle'
          },
          domProps: {
            innerHTML: `Confirm updating new STOP instructions ?`
          }
        })
      ]);

      this.$bvModal.msgBoxConfirm([messageVNode],  {
        title: this.$t('confirm_title'),
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: this.$t('confirm'),
        cancelTitle: this.$t('cancel'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
          .then(value => {
            if (value) {
              this.isUpdatingCloseInstructions = true;
              FirestoreUtils.saveCloseChatInstructions(this.newInstructionsEndChat)
                  .then(() => {
                    this.$toast.success("Close Chat Instructions UPDATED !");
                  })
                  .catch((error) => {
                    window.console.error(error);
                    this.$toast.error(error.message);
                  })
                  .finally(() => {
                    this.isUpdatingCloseInstructions = false;
                  });
            }
          });
    },

    beautify(text) {
      return text.replace(/(\r\n|\r|\n)/g, "<br>");
    } ,

    updateAssistantUI(assistant) {
      this.assistantObj = assistant;
      this.newInstructions = assistant.instructions;
      this.$bvModal.show("assistant-update-modal");
    },

    confirmUpdateAssistant() {
      if (isEmpty(this.newInstructions)) {
        return;
      }

      const h = this.$createElement;
      const messageVNode = h('div', {
        class:'text-center'
      }, [
        h('span', {
          class: "d-inline-block text-muted m-2",
          style: {
            verticalAlign: 'middle'
          },
          domProps: {
            innerHTML: `Confirm updating new instructions to <b>${this.assistantObj.assistantName}</b> ?`
          }
        })
      ]);

      this.$bvModal.msgBoxConfirm([messageVNode],  {
        title: this.$t('confirm_title'),
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: this.$t('confirm'),
        cancelTitle: this.$t('cancel'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          this.updateAssistant(this.assistantObj.assistantId, this.newInstructions.trim());
        }
      });
    },

    cancelUpdateAssistant() {
      this.assistantObj = {
        assistantId: '',
        assistantName: '',
      };
      this.newInstructions = '';
      this.$bvModal.hide("assistant-update-modal");
    },

    updateAssistant(assistantId, instructions) {
      this.isUpdatingAssistant = true;
      const params = {
        assistantId: assistantId,
        instructions: instructions
      };

      AIGeneratorService.updateAssistant(params)
          .then((response) => {
            this.isUpdatingAssistant = false;

            const assistant = this.assistants.find(elt => elt.assistantId === assistantId);
            if (!isEmpty(assistant)) {
              assistant.instructionsId = response.data.instructionsId;
              assistant.instructions = instructions;
            }
            this.cancelUpdateAssistant();
            this.$toast.success("Instructions updates with success !");
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(error.message);
            this.isUpdatingAssistant = false;
          });
    },

    /* User profile */
    openUserPane() {
      if (!this.isUserPaneDisplayed)
        this.isUserPaneDisplayed = true;
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    async showUser(userId, userType) {
      if (!this.isAdmin && userType === 'sender') {
        return;
      }

      const isUserAlreadyDisplayed = this.userTabs.findIndex(x => x.userId === userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        try {
          const result = await UsersDataService.get(userId);
          if (typeof result.data === 'undefined')
            throw new Error('unable to find user '+userId);

          this.userTabs.push(UserUtils.normalize(result.data));
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = userId; }, 100);
      }
    },

    showUserMedia(media, index) {
      this.userMedia.media = media;
      this.userMedia.index = index;
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    }
  },

  created() {
    if (this.getUserRole === Role.Admin || this.getUserRole === Role.Marketing) {
      this.isAdmin = true;
    }

    this.optionsContext = this.isAdmin ? [
      {
        name: this.$t("show_member"),
        value: 'show_user'
      },
      {
        name: this.$t("show_sender"),
        value: 'show_member'
      },
      {
        name: this.$t("ai_generator.show_chatRoom"),
        value: 'thread'
      },
      {
        name: this.$t("search_user"),
        value: 'search'
      },
    ] : [
      {
        name: this.$t("show_member"),
        value: 'show_user'
      },
      {
        name: this.$t("ai_generator.show_chatRoom"),
        value: 'thread'
      },
      {
        name: this.$t("search_user"),
        value: 'search'
      },
    ];
  },

  mounted() {
    this.getFilters();
    if (this.tabIndex === 0)
      this.processFilters();
    else if (this.tabIndex === 1)
      this.processAutoFilters();
    else if (this.tabIndex === 2)
      this.loadAssistants();

  },

  watch: {
    tabIndex: function() {
      if (this.tabIndex === 0 && !this.loaded) {
        this.processFilters();
      } else if (this.tabIndex === 1 && !this.loadedAuto) {
        this.processAutoFilters();
      } else if (this.tabIndex === 2 && !this.loadedAssistants) {
        this.loadAssistants();
      }
    },

    "filters.organic.selected": function (newVal, oldVal) {
      if (oldVal === newVal)
        return;

      if (newVal === "organic") {
        this.filters.ads.selected = 'all';
        this.filters.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (isEmpty(organic)) {
          MarketingDataService.getAdsOrganicFilters()
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filters.ads.options.push(ad);
                });

                organic.ads = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsOrganicFilters"));
              });
        }
        else {
          organic.ads.forEach(ad => {
            this.filters.ads.options.push(ad);
          });
        }
      }
      else if (['marketing', 'all'].includes(newVal) && oldVal === "organic") {
        this.filters.ads.selected = 'all';
        this.filters.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (!isEmpty(marketing)) {
          marketing.ads.forEach(ad => {
            this.filters.ads.options.push(ad);
          });
        }
      }
    },
    "filters.ads.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filters.adsData1.selected = 'all';
      this.filters.adsData2.selected = 'all';
      this.filters.adsData3.selected = 'all';
      this.filters.adsData1.options = [{
        value: 'all', text: 'All Data1'
      }];
      this.filters.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      this.filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(ads[newVal])) {
        MarketingDataService.getAdsNonOrganicData1Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filters.adsData1.options.push(ad);
              });

              ads[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData1Filters"));
            });
      }
      else {
        ads[newVal].forEach(ad => {
          this.filters.adsData1.options.push(ad);
        });
      }
    },
    "filters.adsData1.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filters.adsData2.selected = 'all';
      this.filters.adsData3.selected = 'all';
      this.filters.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      this.filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData1[newVal])) {
        MarketingDataService.getAdsNonOrganicData2Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filters.adsData2.options.push(ad);
              });

              adsData1[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData2Filters"));
            });
      }
      else {
        adsData1[newVal].forEach(ad => {
          this.filters.adsData2.options.push(ad);
        });
      }
    },
    "filters.adsData2.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filters.adsData3.selected = 'all';
      this.filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData2[newVal])) {
        MarketingDataService.getAdsNonOrganicData3Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filters.adsData3.options.push(ad);
              });

              adsData2[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData3Filters"));
            });
      }
      else {
        adsData2[newVal].forEach(ad => {
          this.filters.adsData3.options.push(ad);
        });
      }
    },

    "filtersAuto.organic.selected": function (newVal, oldVal) {
      if (oldVal === newVal)
        return;

      if (newVal === "organic") {
        this.filtersAuto.ads.selected = 'all';
        this.filtersAuto.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (isEmpty(organic)) {
          MarketingDataService.getAdsOrganicFilters()
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filtersAuto.ads.options.push(ad);
                });

                organic.ads = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsOrganicFilters"));
              });
        }
        else {
          organic.ads.forEach(ad => {
            this.filtersAuto.ads.options.push(ad);
          });
        }
      }
      else if (['marketing', 'all'].includes(newVal) && oldVal === "organic") {
        this.filtersAuto.ads.selected = 'all';
        this.filtersAuto.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (!isEmpty(marketing)) {
          marketing.ads.forEach(ad => {
            this.filtersAuto.ads.options.push(ad);
          });
        }
      }
    },
    "filtersAuto.ads.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filtersAuto.adsData1.selected = 'all';
      this.filtersAuto.adsData2.selected = 'all';
      this.filtersAuto.adsData3.selected = 'all';
      this.filtersAuto.adsData1.options = [{
        value: 'all', text: 'All Data1'
      }];
      this.filtersAuto.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      this.filtersAuto.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(ads[newVal])) {
        MarketingDataService.getAdsNonOrganicData1Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filtersAuto.adsData1.options.push(ad);
              });

              ads[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData1Filters"));
            });
      }
      else {
        ads[newVal].forEach(ad => {
          this.filtersAuto.adsData1.options.push(ad);
        });
      }
    },
    "filtersAuto.adsData1.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filtersAuto.adsData2.selected = 'all';
      this.filtersAuto.adsData3.selected = 'all';
      this.filtersAuto.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      this.filtersAuto.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData1[newVal])) {
        MarketingDataService.getAdsNonOrganicData2Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filtersAuto.adsData2.options.push(ad);
              });

              adsData1[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData2Filters"));
            });
      }
      else {
        adsData1[newVal].forEach(ad => {
          this.filtersAuto.adsData2.options.push(ad);
        });
      }
    },
    "filtersAuto.adsData2.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filtersAuto.adsData3.selected = 'all';
      this.filtersAuto.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData2[newVal])) {
        MarketingDataService.getAdsNonOrganicData3Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filtersAuto.adsData3.options.push(ad);
              });

              adsData2[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData3Filters"));
            });
      }
      else {
        adsData2[newVal].forEach(ad => {
          this.filtersAuto.adsData3.options.push(ad);
        });
      }
    }
  },

  data() {
    return {
      tabIndex:0,
      loaded: false,
      loadedAuto: false,
      loadedAssistants: false,
      isLoading: false,
      isLoadingAuto: false,
      isLoadingAssistants: false,
      isUpdatingAssistant: false,
      isUpdatingCloseInstructions: false,
      isUpdatingStartInstructions: false,
      title: this.$t("menuitems.system.ai_stats"),
      generatorSearch: 'filters',
      threads: [],
      threadsAuto: [],
      page: 1,
      pageAuto: 1,
      count: 0,
      countAuto: 0,
      isAdmin: false,
      pageSizes: {
        options: ['20', '50', '100'],
        selected: '50'
      },
      optionsContext: [],

      stats: {
        waiting: '-',
        replied: '-',
        temporary: '-',
        closed: '-',
        answers: '-',
        terminated: '',
        messages: '',
        threads_replies: '',
        avg_message: '',
        avg_replies: ''
      },

      statsAuto: {
        total: '-',
        processed: '-',
        processed_ratio: '-',
        avg_answers: '-',
        avg_accept_delay: '-',
        accepted: '-',
        accepted_ratio: '-',
        expired: '-',
        expired_ratio: '-',
        replied: '-',
        replied_ratio: '-',
        closed: '-',
      },

      typesGraph: {
        series:[],
        chartOptions: {
          chart: {
            id: 'threads-types',
            type: 'donut',
          },
          dataLabels: {
            enabled: true
          },
          labels:[],
          noData: {
            text: 'Loading...'
          },
          legend: {
            position: 'bottom'
          },
        }
      },

      operatorsMessageGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'bar',
            stacked: true,
            stackType: '100%'
          },
          colors: ["#34c38f", "#f8bd25", "#556ee6", "#f06292"],
          plotOptions: {
            bar: {
              horizontal: false,
            },
          },
          fill: {
            opacity: 1

          },
          tooltip: {
            shared: true,
            intersect: false
          },
          dataLabels: {
            enabled: true
          },
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          xaxis: {
            categories: []
          },
          noData: {
            text: 'Loading...'
          },
          legend: {
            position: 'bottom'
          },
        }
      },

      operatorsGraph: {
        series:[],
        chartOptions: {
          chart: {
            id: 'answers-operators',
            type: 'donut',
          },
          dataLabels: {
            enabled: true
          },
          labels:[],
          noData: {
            text: 'Loading...'
          },
          legend: {
            position: 'bottom'
          },
        }
      },

      historyThreadsRepliesGraph: {
        series: [],
        chartOptions: {
          chart: {
            stacked: false,
            type: 'line',
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              dataLabels: {
                total: {
                  enabled: true,
                  style: {
                    fontSize: '13px',
                  }
                }
              }
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              axisTicks: {
                show: true
              },
            }, {
              seriesName: 'AVG Replies',
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#666666'
              },
              labels: {
                style: {
                  colors: '#000000',
                }
              },
              title: {
                text: "AVG Replies /thread",
                style: {
                  color: '#000000',
                }
              },
            },
          ],
          colors: ["#666666", "#34c38f"],
          legend: {
            position: "bottom",
          },
          stroke: {
            curve: "smooth",
            width: 3,
          },
          fill: {
            type:'solid',
            opacity: 1,
          },
        },
      },

      historyMessagesGraph: {
        series: [],
        chartOptions: {
          chart: {
            stacked: false,
            type: 'line',
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              dataLabels: {
                total: {
                  enabled: true,
                  style: {
                    fontSize: '13px',
                  }
                }
              }
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          colors: ["#666666", "#556ee6"],
          legend: {
            position: "bottom",
          },
          stroke: {
            curve: "smooth",
            width: 3,
          },
          fill: {
            type:'solid',
            opacity: [0.35, 1],
          },
        },
      },

      historyAvgThreadsGraph: {
        series: [],
        chartOptions: {
          chart: {
            stacked: false,
            type: 'line',
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              dataLabels: {
                total: {
                  enabled: true,
                  style: {
                    fontSize: '13px',
                  }
                }
              }
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          colors: ["#333333"],
          legend: {
            position: "bottom",
          },
          stroke: {
            curve: "smooth",
            width: 3,
          },
          fill: {
            type:'solid',
            opacity: [0.35, 1],
          },
        },
      },

      historyAvgThreadsTypeGraph: {
        series: [],
        chartOptions: {
          chart: {
            stacked: false,
            type: 'line',
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              dataLabels: {
                total: {
                  enabled: true,
                  style: {
                    fontSize: '13px',
                  }
                }
              }
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          colors: ["#50A5F1", "#556EE6", "#34C38F", "#E83E8C"],
          legend: {
            position: "bottom",
          },
          stroke: {
            curve: "smooth",
            width: 3,
          },
          fill: {
            type:'solid',
            opacity: [0.35, 1],
          },
        },
      },

      historyOperatorsGraph: {
        series: [],
        chartOptions: {
          chart: {
            stacked: false,
            type: 'bar',
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              dataLabels: {
                total: {
                  enabled: true,
                  style: {
                    fontSize: '13px',
                  }
                }
              }
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },

      historyGraph: {
        series: [],
        chartOptions: {
          chart: {
            stacked: true,
            type: 'bar',
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
              borderRadius: 10,
              dataLabels: {
                total: {
                  enabled: true,
                  style: {
                    fontSize: '13px',
                  }
                }
              }
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          colors: ["#f8bd25", "#34c38f", "#f06292", "#556ee6"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },

      closedReasonsGraph: {
        series:[],
        chartOptions: {
          chart: {
            id: 'threads-closed-reason',
            type: 'donut',
          },
          dataLabels: {
            enabled: true
          },
          labels:[],
          noData: {
            text: 'Loading...'
          },
          legend: {
            position: 'bottom'
          },
        }
      },

      autoStatusGraph: {
        series:[],
        chartOptions: {
          chart: {
            id: 'threads-status-auto',
            type: 'donut',
          },
          dataLabels: {
            enabled: true
          },
          labels:[],
          noData: {
            text: 'Loading...'
          },
          legend: {
            position: 'bottom'
          },
          colors: ["#f06292", "#34c38f", "#556ee6", "#f8bd25", "#666666"],
        }
      },

      historyAutoStatusGraph: {
        series: [],
        chartOptions: {
          chart: {
            stacked: true,
            type: 'bar',
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
              borderRadius: 10,
              dataLabels: {
                total: {
                  enabled: true,
                  style: {
                    fontSize: '13px',
                  }
                }
              }
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          colors: ["#f06292", "#34c38f", "#556ee6", "#f8bd25"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },

      filters: {
        searchType: {
          selected: 'userId',
          options: [
            {value:'userId', text:this.$t("userId")},
            {value:'email', text:this.$t("email")}
          ]
        },
        searchData: "",
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'week',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        genders: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("users.all_genders")},
            {value: 1, text: this.$t("users.search.genderMale")},
            {value: 2, text: this.$t("users.search.genderFemale")}
          ]
        },
        organic: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Source'},
            {value: 'organic', text: 'Only Organic'},
            {value: 'marketing', text: 'Only Marketing'}
          ]
        },
        iceBreaker: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All IceBreakers'},
            {value: 'Y', text: 'Only IceBreakers'},
            {value: 'N', text: 'No IceBreakers'},
          ]
        },
        threadType: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Thread type'},
            {value: 'DS', text: 'Only All Defaults'},
            {value: 'D', text: 'Only Default'},
            {value: 'S', text: 'Only Default Subscribed'},
            {value: 'I', text: 'Only IceBreakers'},
            {value: 'M', text: 'Only Matches'},
          ]
        },
        ads: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Ads'
          }]
        },
        adsData1: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data1'
          }]
        },
        adsData2: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data2'
          }]
        },
        adsData3: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data3'
          }]
        },
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
        // W: Waiting I: Inserted S: Success p: Processed E: Empty, NP: No Photo, EL: Empty Location, EF: Empty Finish, ERR: Error
        status: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("ai_generator.status_all")},
            {value: 'R', text: this.$t("ai_generator.status_R")},
            {value: 'W', text: this.$t("ai_generator.status_W")},
            {value: 'T', text: this.$t("ai_generator.status_T")},
            {value: 'D', text: this.$t("ai_generator.status_D")},
          ]
        },
      },

      filtersAuto: {
        searchType: {
          selected: 'userId',
          options: [
            {value:'userId', text:this.$t("userId")},
            {value:'email', text:this.$t("email")}
          ]
        },
        searchData: "",
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'week',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        status: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Status'},
            {value: 'I', text: 'IA connected'},
            {value: 'X', text: 'Not Accepted'},
            {value: 'A', text: 'No Replies'},
            {value: 'R', text: 'Late Replies'},
          ]
        },
        genders: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("users.all_genders")},
            {value: 1, text: this.$t("users.search.genderMale")},
            {value: 2, text: this.$t("users.search.genderFemale")}
          ]
        },
        organic: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Source'},
            {value: 'organic', text: 'Only Organic'},
            {value: 'marketing', text: 'Only Marketing'}
          ]
        },
        ads: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Ads'
          }]
        },
        adsData1: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data1'
          }]
        },
        adsData2: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data2'
          }]
        },
        adsData3: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data3'
          }]
        },
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
      },

      /* Chat */
      threadActive: '',

      /* Assistants */
      assistants: [],
      newInstructions: '',
      newInstructionsEndChat: '',
      newInstructionsStartChat: '',
      assistantObj: {
        assistantName: '',
        assistantId: '',
      },
      instructionsEndChat: {
        instructions: '',
        updatedAt: ''
      },
      instructionsStartChat: {
        instructions: '',
        updatedAt: ''
      },

      /* User profile */
      isUserPaneDisplayed: false,
      userTabs:[],
      userTabsActive: '',
      userMedia: {
        media: [],
        index: -1
      },
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">
      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <b-tabs content-class="" v-model="tabIndex">

        <!-- stats tab -->
        <b-tab>
          <template #title>
            <i class="far fa-user"></i> Chats
          </template>
          <div class="card">
            <div class="card-body">

              <!-- Filters -->
              <div class="card" v-show="isAdmin">
                <div class="card-body">
                  <!-- Search -->
                  <b-form inline class="row gy-2 gx-3 align-items-center" id="generatorSearchForm" @submit.stop.prevent>
                    <div class="col-sm-auto">
                      <b-form-select
                          id="generatorSearchTypeFilter"
                          v-model="filters.searchType.selected"
                          class="form-select me-lg-1"
                          :options="filters.searchType.options">
                      </b-form-select>
                    </div>
                    <div class="col-sm-auto">
                      <b-form-input
                          id="generatorSearchData"
                          class="me-lg-1"
                          v-model="filters.searchData"
                          placeholder="Search…">
                      </b-form-input>
                    </div>
                    <div class="col-sm-auto">
                      <b-button variant="primary" class="w-md" @click="processSearch(true)">{{ $t("searchBtn") }}</b-button>
                    </div>
                  </b-form>
                  <hr />
                  <!-- filters -->
                  <b-form inline class="row gy-2 gx-3 align-items-center" id="generatorFiltersForm" @submit.stop.prevent>

                    <!-- dates -->
                    <div class="col-sm-auto d-flex">
                      <b-form-select
                          id="generatorDatesFilter"
                          @change="handleDateChange"
                          v-model="filters.dates.selected"
                          class="form-select me-lg-1"
                          :options="filters.dates.options">
                      </b-form-select>
                      <date-picker
                          v-show="filters.dates.selected === 'custom'"
                          :placeholder="this.$t('choose_date_interval')"
                          type="date"
                          value-type="format"
                          show-week-number
                          v-model="filters.dates.dateRange"
                          class="me-lg-2"
                          range append-to-body ></date-picker>

                    </div>

                    <!-- Countries -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="generatorCountriesFilter"
                          v-model="filters.countries.selected"
                          class="form-select me-lg-1"
                          :options="filters.countries.options">
                      </b-form-select>
                    </div>

                    <!-- Genders -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="generatorGenderFilter"
                          v-model="filters.genders.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="ct in filters.genders.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- Status -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="generatorStatusFilter"
                          v-model="filters.status.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="st in filters.status.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- IceBreaker -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="generatorIceBreakerFilter"
                          v-model="filters.iceBreaker.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="ct in filters.iceBreaker.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- threadType -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="generatorThreadTypeFilter"
                          v-model="filters.threadType.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="ct in filters.threadType.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- Organic -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="generatorOrganicFilter"
                          v-model="filters.organic.selected"
                          class="form-select me-lg-1"
                          :options="filters.organic.options">
                      </b-form-select>
                    </div>

                    <!-- Ads -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="generatorAdsFilter"
                          v-model="filters.ads.selected"
                          class="form-select me-lg-1"
                          :options="filters.ads.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto" v-show="filters.ads.selected !== 'all'">
                      <b-form-select
                          id="generatorAdsData1Filter"
                          v-model="filters.adsData1.selected"
                          class="form-select me-lg-1"
                          :options="filters.adsData1.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto" v-show="filters.adsData1.selected !== 'all'">
                      <b-form-select
                          id="generatorAdsData2Filter"
                          v-model="filters.adsData2.selected"
                          class="form-select me-lg-1"
                          :options="filters.adsData2.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto" v-show="filters.adsData2.selected !== 'all'">
                      <b-form-select
                          id="generatorAdsData3Filter"
                          v-model="filters.adsData3.selected"
                          class="form-select me-lg-1"
                          :options="filters.adsData3.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto">
                      <b-button variant="primary" class="w-md" @click="processFilters">{{ $t("find") }}</b-button>
                    </div>
                  </b-form>
                </div>
              </div>

              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="isLoading"
                    :loading="isLoading"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- Stats Admin Plain -->
              <div class="row" v-if="generatorSearch === 'filters' && isAdmin">
                <!-- Success -->
                <div class="col-lg-4">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">Threads Status {{ $t("ai_generator.replied") }}</p>
                          <h4 class="mb-0">{{ stats.replied }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                          <span class="avatar-title bg-success">
                            <i class="bx bx-check font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Waiting -->
                <div class="col-lg-4">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">Threads Status {{ $t("ai_generator.waiting") }}</p>
                          <h4 class="mb-0">{{ stats.waiting }} <span class="font-size-12 text-primary">{{ stats.temporary }} temp</span></h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                          <span class="avatar-title bg-warning">
                            <i class="bx bx-check font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Closed -->
                <div class="col-lg-4">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-muted fw-medium mb-2">Threads Status {{ $t("ai_generator.closed") }}</p>
                          <h4 class="mb-0">{{ stats.closed }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                          <span class="avatar-title bg-pink">
                            <i class="bx bx-error font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row" v-if="generatorSearch === 'filters' && isAdmin">
                <!-- Threads Replied -->
                <div class="col-lg-3">
                  <div class="card mini-stats-wid">
                    <div class="card-body bg-info">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-white fw-medium mb-2">{{ $t("ai_generator.threads_replied") }}</p>
                          <h4 class="text-white mb-0">{{ stats.threads_replies }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Answers -->
                <div class="col-lg-3">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("ai_generator.answers") }}</p>
                          <h4 class="mb-0">{{ stats.answers }} <span class="font-size-12 text-primary">{{ stats.avg_replies }} /thread</span></h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                          <span class="avatar-title bg-primary">
                            <i class="bx bx-check font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Messages -->
                <div class="col-lg-3">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("ai_generator.messages_sent") }}</p>
                          <h4 class="mb-0">{{ stats.messages }} <span class="font-size-12 text-primary">{{ stats.avg_message }} /thread</span></h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                          <span class="avatar-title bg-primary">
                            <i class="bx bx-check font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Users End -->
                <div class="col-lg-3">
                  <div class="card mini-stats-wid">
                    <div class="card-body bg-danger">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-white fw-medium mb-2">{{ $t("ai_generator.users_terminated") }}</p>
                          <h4 class="text-white mb-0">{{ stats.terminated }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <!-- Stats Plain -->
              <div class="row" v-if="generatorSearch === 'filters' && !isAdmin">
                <!-- Waiting -->
                <div class="col-lg-6">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("ai_generator.waiting") }}</p>
                          <h4 class="mb-0">{{ stats.waiting }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                          <span class="avatar-title bg-warning">
                            <i class="bx bx-check font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- temporary -->
                <div class="col-lg-6">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("ai_generator.temporary") }}</p>
                          <h4 class="mb-0">{{ stats.temporary }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                          <span class="avatar-title bg-info">
                            <i class="bx bx-info-circle font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row" v-if="generatorSearch === 'filters'" v-show="isAdmin">

                <div class="col-12 col-lg-4">
                  <!-- graph Types -->
                  <div class="card">
                    <div class="card-body" id="cardChartTypes">
                      <h5 class="card-title">Threads Origin Types</h5>
                      <apexchart
                          ref="generatorTypesChart"
                          height="350"
                          type="donut"
                          dir="ltr"
                          :series="typesGraph.series"
                          :options="typesGraph.chartOptions"
                      ></apexchart>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-4">
                  <!-- operators Types -->
                  <div class="card">
                    <div class="card-body" id="cardChartTypes">
                      <h5 class="card-title">Operators Messages Distribution</h5>
                      <apexchart
                          ref="generatorOperatorsChart"
                          height="350"
                          type="donut"
                          dir="ltr"
                          :series="operatorsGraph.series"
                          :options="operatorsGraph.chartOptions"
                      ></apexchart>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-4">
                  <!-- operators messageTypes -->
                  <div class="card">
                    <div class="card-body" id="cardChartTypes">
                      <h5 class="card-title">Operators Messages Type</h5>
                      <apexchart
                          ref="generatorOperatorsMessageChart"
                          height="300"
                          type="bar"
                          dir="ltr"
                          :series="operatorsMessageGraph.series"
                          :options="operatorsMessageGraph.chartOptions"
                      ></apexchart>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row" v-if="generatorSearch === 'filters'" v-show="isAdmin">
                <!-- History -->
                <div class="col-12 col-lg-6">
                  <div class="card">
                    <div class="card-body" id="cardChartGeneratorHistory">
                      <h5 class="card-title">Threads Status History</h5>
                      <apexchart
                          ref="generatorHistoryChart"
                          class="apex-charts"
                          type="bar"
                          dir="ltr"
                          height="300"
                          :series="historyGraph.series"
                          :options="historyGraph.chartOptions"
                      ></apexchart>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-6">
                  <div class="card">
                    <div class="card-body" id="cardChartGeneratorHistoryOp">
                      <h5 class="card-title">Operators Replies History</h5>
                      <apexchart
                          ref="generatorOperatorsHistoryGraph"
                          class="apex-charts"
                          type="bar"
                          dir="ltr"
                          height="300"
                          :series="historyOperatorsGraph.series"
                          :options="historyOperatorsGraph.chartOptions"
                      ></apexchart>
                    </div>
                  </div>
                </div>

              </div>

          <div class="row" v-if="generatorSearch === 'filters' && isAdmin">

            <div class="col-12 col-lg-6">
              <div class="card">
                <div class="card-body" id="cardChartGeneratorHistoryMessages">
                  <h5 class="card-title">Messages History</h5>
                  <apexchart
                      ref="generatorMessagesHistoryGraph"
                      class="apex-charts"
                      type="line"
                      dir="ltr"
                      height="300"
                      :series="historyMessagesGraph.series"
                      :options="historyMessagesGraph.chartOptions"
                  ></apexchart>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="card">
                <div class="card-body" id="cardChartGeneratorHistoryMessages">
                  <h5 class="card-title">Threads Replies & AVG History</h5>
                  <apexchart
                      ref="generatorThreadsRepliesHistoryGraph"
                      class="apex-charts"
                      type="line"
                      dir="ltr"
                      height="300"
                      :series="historyThreadsRepliesGraph.series"
                      :options="historyThreadsRepliesGraph.chartOptions"
                  ></apexchart>
                </div>
              </div>
            </div>


          </div>

              <div class="row" v-if="generatorSearch === 'filters' && isAdmin">

                <div class="col-12 col-lg-6">
                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title">AVG Threads per User</h5>
                      <apexchart
                          ref="generatorThreadsAvgHistoryGraph"
                          class="apex-charts"
                          type="line"
                          dir="ltr"
                          height="300"
                          :series="historyAvgThreadsGraph.series"
                          :options="historyAvgThreadsGraph.chartOptions"
                      ></apexchart>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-6">
                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title">AVG Threads Types per User</h5>
                      <apexchart
                          ref="generatorThreadsTypesAvgHistoryGraph"
                          class="apex-charts"
                          type="line"
                          dir="ltr"
                          height="300"
                          :series="historyAvgThreadsTypeGraph.series"
                          :options="historyAvgThreadsTypeGraph.chartOptions"
                      ></apexchart>
                    </div>
                  </div>
                </div>


              </div>


              <!-- Top list tools -->
              <div class="row mb-3">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>

                  {{ count }} {{ $t('resultsCount') }}
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="page"
                        :total-rows="count"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handlePageChange"
                        aria-controls="generator-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>
              <!-- Result list -->
              <div class="row bg-white" v-if="!isLoading && threads.length > 0">
                <div class="table-responsive card-body">
                  <table
                      id="generator-list"
                      class="table project-list-table table-centered table-borderless align-middle"
                  >
                    <thead>
                    <tr>
                      <th scope="col">{{ $t('generator.scheduledAt') }}</th>
                      <th scope="col">{{ $t('generator.status') }}</th>
                      <th scope="col">{{ $t('generator.user') }}</th>
                      <th scope="col">{{ $t('generator.user') }} Info</th>
                      <th scope="col">{{ $t('ai_generator.sender') }}</th>
                      <th scope="col" v-if="isAdmin">Source</th>
                      <th scope="col" v-if="isAdmin">IceBreaker</th>
                      <th scope="col">Thread</th>
                      <th scope="col" v-if="isAdmin">Tokens</th>
                      <th scope="col">{{ $t('action') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in threads" :key="row.threadId" @contextmenu.prevent.stop="showContextMenu($event, row)">
                      <td>
                        <p class="text-muted font-size-12">{{ formatDateString(row.actionDate, 'DD MMM YYYY HH:mm') }}</p>
                        <b-button variant="primary" class="w-md" @click="showThread(row)">{{ $t("ai_generator.show_chatRoom") }}</b-button>
                      </td>
                      <td>
                <span
                    class="badge"
                    :class="{
                      'bg-success text-light': `${row.status}` === 'R',
                      'bg-info text-light': `${row.status}` === 'T',
                      'bg-pink text-light': `${row.status}` === 'D',
                      'bg-warning text-dark': `${row.status}` === 'W',
                    }"
                >{{ $t(`ai_generator.status_${row.status}`) }}</span>
                      </td>
                      <td @click="showUser(row.userId, 'user')">
                        <div class="media">
                          <div class="avatar-xs">
                            <img
                                :id="`ai-generator-user-${row.threadId}`"
                                :src="require('@/assets/images/users/default-user.png')"
                                class="d-flex rounded-circle avatar-xs" />
                          </div>
                          <div class="media-body ms-1">
                            <h5 class="font-size-14 mb-0">
                      <span
                          :class="{
                          'text-primary': row.sex === 1,
                          'text-danger': row.sex === 2,
                          'text-dark': row.sex === 0,
                        }"
                      >
                        {{ row.name || '-' }}
                      </span> {{ getAge(row.birth) }}</h5>
                            <small class="text-muted">#{{ row.userId }}</small><br>
                            <small class="text-muted">{{ row.country }}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span v-show="row.userStatus === 'D'" class="badge bg-danger text-light">Disabled</span>
                        <br><small><b>{{ row.threadsCount }}</b> threads</small>
                      </td>
                      <td @click="showUser(row.senderId, 'sender')">
                        <div class="media" v-show="row.senderId !== null ">
                          <div class="avatar-xs">
                            <img
                                :id="`ai-generator-user-${row.threadId}-sender`"
                                :src="require('@/assets/images/users/default-user.png')"
                                class="d-flex rounded-circle avatar-xs" />
                          </div>
                          <div class="media-body ms-1">
                            <h5 class="font-size-14 mb-0">
                      <span
                          :class="{
                          'text-primary': row.senderSex === 1,
                          'text-danger': row.senderSex === 2,
                          'text-dark': row.senderSex === 0,
                        }"
                      >
                        {{ row.senderName || '-' }}
                      </span> {{ getAge(row.senderBirth) }}</h5>
                            <small class="text-muted">#{{ row.senderId }}</small><br>
                            <small class="text-muted">{{ row.senderCountry }}</small>
                          </div>
                        </div>
                      </td>
                      <td v-if="isAdmin">
                <span
                    class="badge"
                    :class="{
                      'bg-pink': `${row.threadType}` === 'I',
                      'bg-success': `${row.threadType}` === 'M',
                      'bg-info': `${row.threadType}` === 'D',
                      'bg-primary': `${row.threadType}` === 'S',
                      'bg-dark': `${row.threadType}` === 'A',

                    }"
                >{{ $t(`ai_generator.threadtype_${row.threadType}`)}}</span>
                      </td>
                      <td v-if="isAdmin">
                        <span v-show="row.iceBreaker === 1" class="badge bg-pink text-light">IceBreaker</span>
                      </td>

                      <td>
                        <small>{{ row.aiThreadId }}</small><br>
                        <small>{{ row.chatRoomId }}</small>
                      </td>
                      <td v-if="isAdmin">
                        <b>{{ row.tokenInput }} / {{ row.tokenOutput }}</b>
                      </td>
                      <td>
                        <b-dropdown
                            class="card-drop"
                            variant="white"
                            menu-class="dropdown-menu-end"
                            right
                            toggle-class="p-0"
                        >
                          <template v-slot:button-content>
                            <i class="mdi mdi-dots-horizontal font-size-18"></i>
                          </template>
                          <b-dropdown-item
                              href="javascript: void(0);"
                              @click="showUser(row.userId, 'user')"
                          >{{ $t("show_member") }}</b-dropdown-item>
                          <b-dropdown-item
                              v-if="isAdmin"
                              href="javascript: void(0);"
                              @click="showUser(row.senderId, 'sender')"
                          >{{ $t("show_sender") }}</b-dropdown-item>
                          <b-dropdown-item
                              href="javascript: void(0);"
                              @click="showThread(row)"
                          >{{ $t("ai_generator.show_chatRoom") }}</b-dropdown-item>
                          <b-dropdown-item
                              href="javascript: void(0);"
                              @click="searchUser(row.userId)"
                          >{{ $t("search_user") }}</b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- Result Empty -->
              <div class="row" v-if="!isLoading && threads.length === 0">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Empty Result</h4>
                      <p>No Schedule were found for these filters or search. Try again.</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- bottom list tools -->
              <div class="row mb-3">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="page"
                        :total-rows="count"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handlePageChange"
                        aria-controls="generator-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>

        <!-- auto AI -->
        <b-tab v-if="isAdmin">
          <template #title>
            <i class="far fa-user"></i> Auto IA
          </template>
          <div class="card">
            <div class="card-body">

              <!-- Filters -->
              <div class="card">
                <div class="card-body">
                  <!-- filters -->
                  <b-form inline class="row gy-2 gx-3 align-items-center" id="generatorFiltersForm" @submit.stop.prevent>

                    <!-- dates -->
                    <div class="col-sm-auto d-flex">
                      <b-form-select
                          id="generatorDatesFilter"
                          @change="handleAutoDateChange"
                          v-model="filtersAuto.dates.selected"
                          class="form-select me-lg-1"
                          :options="filtersAuto.dates.options">
                      </b-form-select>
                      <date-picker
                          v-show="filtersAuto.dates.selected === 'custom'"
                          :placeholder="this.$t('choose_date_interval')"
                          type="date"
                          value-type="format"
                          show-week-number
                          v-model="filtersAuto.dates.dateRange"
                          class="me-lg-2"
                          range append-to-body ></date-picker>

                    </div>

                    <!-- status -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="generatorStatusFilter"
                          v-model="filtersAuto.status.selected"
                          class="form-select me-lg-1"
                          :options="filtersAuto.status.options">
                      </b-form-select>
                    </div>

                    <!-- Countries -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="generatorCountriesFilter"
                          v-model="filtersAuto.countries.selected"
                          class="form-select me-lg-1"
                          :options="filtersAuto.countries.options">
                      </b-form-select>
                    </div>

                    <!-- Genders -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="generatorGenderFilter"
                          v-model="filtersAuto.genders.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="ct in filtersAuto.genders.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- Organic -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="generatorOrganicFilter"
                          v-model="filtersAuto.organic.selected"
                          class="form-select me-lg-1"
                          :options="filtersAuto.organic.options">
                      </b-form-select>
                    </div>

                    <!-- Ads -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="generatorAdsFilter"
                          v-model="filtersAuto.ads.selected"
                          class="form-select me-lg-1"
                          :options="filtersAuto.ads.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto" v-show="filtersAuto.ads.selected !== 'all'">
                      <b-form-select
                          id="generatorAdsData1Filter"
                          v-model="filtersAuto.adsData1.selected"
                          class="form-select me-lg-1"
                          :options="filtersAuto.adsData1.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto" v-show="filtersAuto.adsData1.selected !== 'all'">
                      <b-form-select
                          id="generatorAdsData2Filter"
                          v-model="filtersAuto.adsData2.selected"
                          class="form-select me-lg-1"
                          :options="filtersAuto.adsData2.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto" v-show="filtersAuto.adsData2.selected !== 'all'">
                      <b-form-select
                          id="generatorAdsData3Filter"
                          v-model="filtersAuto.adsData3.selected"
                          class="form-select me-lg-1"
                          :options="filtersAuto.adsData3.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto">
                      <b-button variant="primary" class="w-md" @click="processAutoFilters">{{ $t("find") }}</b-button>
                    </div>
                  </b-form>
                </div>
              </div>

              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="isLoadingAuto"
                    :loading="isLoadingAuto"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- Stats Threads Auto -->
              <div class="row">
                <div class="card mb-3">
                  <div class="card-body">
                    <h3 class="mb-4">Auto AI Stats</h3>

                    <div class="row">

                      <!-- Total -->
                      <div class="col-lg-2">
                        <div class="card mini-stats-wid">
                          <div class="card-body">
                            <div class="media">
                              <div class="media-body">
                                <p class="text-dark fw-medium mb-2">Ice Breakers Sent</p>
                                <h4 class="mb-0">{{ statsAuto.total }}<span class="font-size-12 ms-2 text-primary">{{ statsAuto.closed }} closed</span></h4>
                              </div>

                              <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                            <span class="avatar-title bg-dark">
                              <i class="bx bx-send font-size-24"></i>
                            </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Expired -->
                      <div class="col-lg-2">
                        <div class="card mini-stats-wid">
                          <div class="card-body">
                            <div class="media">
                              <div class="media-body">
                                <p class="text-muted fw-medium mb-2">Not Accepted</p>
                                <h4 class="mb-0">{{ statsAuto.expired }}<span class="font-size-12 ms-2 text-primary">{{ statsAuto.expired_ratio }}%</span></h4>
                              </div>

                              <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                            <span class="avatar-title bg-pink">
                              <i class="bx bx-error font-size-24"></i>
                            </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- accepted -->
                      <div class="col-lg-2">
                        <div class="card mini-stats-wid">
                          <div class="card-body">
                            <div class="media">
                              <div class="media-body">
                                <p class="text-dark fw-medium mb-2">Accepted</p>
                                <h4 class="mb-0">{{ statsAuto.accepted }}<span class="font-size-12 ms-2 text-primary">{{ statsAuto.accepted_ratio }}%</span></h4>
                              </div>

                              <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                            <span class="avatar-title bg-warning">
                              <i class="bx bx-check font-size-24"></i>
                            </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Replied -->
                      <div class="col-lg-2">
                        <div class="card mini-stats-wid">
                          <div class="card-body">
                            <div class="media">
                              <div class="media-body">
                                <p class="text-muted fw-medium mb-2">Replied</p>
                                <h4 class="mb-0">{{ statsAuto.replied }}<span class="font-size-12 text-primary ms-2">{{ statsAuto.replied_ratio }}%</span></h4>
                              </div>

                              <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                            <span class="avatar-title bg-info">
                              <i class="bx bx-message font-size-24"></i>
                            </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Processed -->
                      <div class="col-lg-2">
                        <div class="card mini-stats-wid">
                          <div class="card-body bg-success">
                            <div class="media">
                              <div class="media-body">
                                <p class="text-white fw-medium mb-2">IA Connected</p>
                                <h4 class="text-white mb-0">{{ statsAuto.processed }}<span class="font-size-12 ms-2 text-white">{{ statsAuto.processed_ratio }}%</span></h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- AVG -->
                      <div class="col-lg-2">
                        <div class="card mini-stats-wid">
                          <div class="card-body">
                            <div class="media">
                              <div class="media-body">
                                <p class="text-muted fw-medium mb-2">AVG IA msg/thread <span class="float-end h6 text-black">{{ statsAuto.avg_answers }}</span></p>
                                <p class="text-muted fw-medium mb-2">AVG delay accept <span class="float-end h6 text-black">{{ statsAuto.avg_accept_delay }}</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="row">

                      <div class="col-12 col-lg-3">
                        <!-- graph closed reasons -->
                        <div class="card">
                          <div class="card-body" id="cardChartReasons">
                            <h5 class="card-title">Closed Reasons</h5>
                            <apexchart
                                ref="generatorReasonsChart"
                                height="350"
                                type="donut"
                                dir="ltr"
                                :series="closedReasonsGraph.series"
                                :options="closedReasonsGraph.chartOptions"
                            ></apexchart>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-lg-3">
                        <!-- graph auto status -->
                        <div class="card">
                          <div class="card-body" id="cardChartAutoStatus">
                            <h5 class="card-title">Status</h5>
                            <apexchart
                                ref="generatorStatusChart"
                                height="350"
                                type="donut"
                                dir="ltr"
                                :series="autoStatusGraph.series"
                                :options="autoStatusGraph.chartOptions"
                            ></apexchart>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-lg-6">
                        <!-- graph histo status -->
                        <div class="card">
                          <div class="card-body" id="cardChartAutoHistory">
                            <h5 class="card-title">History by Status</h5>
                            <apexchart
                                ref="generatorAutoHistoryStatusChart"
                                height="350"
                                type="bar"
                                dir="ltr"
                                :series="historyAutoStatusGraph.series"
                                :options="historyAutoStatusGraph.chartOptions"
                            ></apexchart>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>

              </div>

              <!-- Top list tools -->
              <div class="row mb-3">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>

                  {{ countAuto }} {{ $t('resultsCount') }}
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pageAuto"
                        :total-rows="countAuto"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handleAutoPageChange"
                        aria-controls="generator-auto-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

              <!-- Result list -->
              <div class="row bg-white" v-if="!isLoadingAuto && threadsAuto.length > 0">
                <div class="table-responsive card-body">
                  <table
                      id="generator-list"
                      class="table project-list-table table-centered table-borderless align-middle"
                  >
                    <thead>
                    <tr>
                      <th scope="col">Created</th>
                      <th scope="col">Accepted</th>
                      <th scope="col">{{ $t('generator.status') }}</th>
                      <th scope="col">{{ $t('generator.user') }}</th>
                      <th scope="col">{{ $t('ai_generator.sender') }}</th>
                      <th scope="col">Thread</th>
                      <th scope="col">Tokens</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in threadsAuto" :key="row.threadId" @contextmenu.prevent.stop="showContextMenu($event, row)">
                      <td>
                        <p class="text-muted font-size-12">{{ formatDateString(row.ibfCreatedAt, 'DD MMM YYYY HH:mm') }}</p>
                        <b-button variant="primary" class="w-md" v-if="row.processed === 1" @click="showThread(row)">{{ $t("ai_generator.show_chatRoom") }}</b-button>
                      </td>
                      <td>
                        <p class="text-muted fw-bold font-size-12" v-if="!_isEmpty(row.acceptedAt)">{{ formatDateString(row.acceptedAt, 'DD MMM YYYY HH:mm') }}</p>
                      </td>
                      <td>
                <span
                    class="badge"
                    :class="{
                      'bg-success text-light': `${row.ibfStatus}` === 'I',
                      'bg-info text-light': `${row.ibfStatus}` === 'R',
                      'bg-pink text-light': `${row.ibfStatus}` === 'X',
                      'bg-warning text-dark': `${row.ibfStatus}` === 'A',
                      'bg-light text-dark': `${row.ibfStatus}` === 'W',
                    }"
                >{{ $t(`ai_generator.status_auto_${row.ibfStatus}`) }}</span>
                        <span v-if="row.answers > 0"><br><small>{{ row.answers}} answers</small></span>
                      </td>
                      <td @click="showUser(row.userId, 'user')">
                        <div class="media">
                          <div class="avatar-xs">
                            <img
                                :id="`ai-generator-user-${row.chatRoomId}`"
                                :src="require('@/assets/images/users/default-user.png')"
                                class="d-flex rounded-circle avatar-xs" />
                          </div>
                          <div class="media-body ms-1">
                            <h5 class="font-size-14 mb-0">
                      <span
                          :class="{
                          'text-primary': row.sex === 1,
                          'text-danger': row.sex === 2,
                          'text-dark': row.sex === 0,
                        }"
                      >
                        {{ row.name || '-' }}
                      </span> {{ getAge(row.birth) }}</h5>
                            <small class="text-muted">#{{ row.userId }}</small><br>
                            <small class="text-muted">{{ row.country }}</small>
                          </div>
                        </div>
                      </td>
                      <td @click="showUser(row.senderId, 'sender')">
                        <div class="media" v-show="row.senderId !== null ">
                          <div class="avatar-xs">
                            <img
                                :id="`ai-generator-user-${row.chatRoomId}-sender`"
                                :src="require('@/assets/images/users/default-user.png')"
                                class="d-flex rounded-circle avatar-xs" />
                          </div>
                          <div class="media-body ms-1">
                            <h5 class="font-size-14 mb-0">
                      <span
                          :class="{
                          'text-primary': row.senderSex === 1,
                          'text-danger': row.senderSex === 2,
                          'text-dark': row.senderSex === 0,
                        }"
                      >
                        {{ row.senderName || '-' }}
                      </span> {{ getAge(row.senderBirth) }}</h5>
                            <small class="text-muted">#{{ row.senderId }}</small><br>
                            <small class="text-muted">{{ row.senderCountry }}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span v-if="row.processed === 1"><small>{{ row.aiThreadId }}</small><br></span>
                        <small>{{ row.chatRoomId }}</small>
                        <span v-if="row.closed === 1" class="text-primary"><br><small>Closed</small></span>
                        <span v-if="!_isEmpty(row.closedReason)" class="ms-1"><small><b>{{ row.closedReason }}</b></small></span>
                      </td>
                      <td>
                        <span v-if="row.processed === 1"><b>{{ row.tokenInput }} / {{ row.tokenOutput }}</b></span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Result Empty -->
              <div class="row" v-if="!isLoadingAuto && threadsAuto.length === 0">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Empty Result</h4>
                      <p>No Auto Thread found. Try again.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- bottom list tools -->
              <div class="row mb-3">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pageAuto"
                        :total-rows="countAuto"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handleAutoPageChange"
                        aria-controls="generator-auto-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </b-tab>

        <!-- assistants AI -->
        <b-tab v-if="isAdmin">
          <template #title>
            <i class="far fa-user"></i> Assistants Settings
          </template>
          <div class="card">
            <div class="card-body">

              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="isLoadingAssistants"
                    :loading="isLoadingAssistants"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- Start Chat Instructions -->
              <div class="rounded-4 bg-info bg-opacity-25 p-3 mb-4">
                <h4>Instructions Start Chat</h4>
                <p><small class="text-primary ms-2">Last update: <b>{{ formatDateTimestamp(instructionsStartChat.updatedAt.seconds, 'DD MMM YYYY HH:mm') }}</b></small></p>
                <hr/>
                <b-form-textarea
                    v-model="newInstructionsStartChat"
                    rows="6"
                    class="bg-white text-black font-size-13"
                    placeholder="Type reply…"
                    :state="newInstructionsStartChat.length >= 20"
                >
                </b-form-textarea>
                <p class="mt-1"><small>
                  <b>Variables Available:</b>
                  <br>Member: {user_name} {user_age} {user_locality} {user_country} {user_language}
                  <br>Sender: {sender_name} {sender_age} {sender_locality} {sender_country}
                  <br>Misc: {today}
                </small></p>

                <b-button v-show="!isUpdatingStartInstructions && newInstructionsStartChat !== instructionsStartChat.instructions" variant="primary" class="mt-2 w-md" @click="updateStartChatInstructions">Edit Start instructions</b-button>
                <vue-ellipse-progress
                    v-show="isUpdatingStartInstructions"
                    :loading="isUpdatingStartInstructions"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="50"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- Close Chat Instructions -->
              <div class="rounded-4 bg-warning p-3 mb-4">
                <h4>Instructions Terminate Chat</h4>
                <p><small class="text-black ms-2">Last update: <b>{{ formatDateTimestamp(instructionsEndChat.updatedAt.seconds, 'DD MMM YYYY HH:mm') }}</b></small></p>
                <hr/>
                <b-form-textarea
                    v-model="newInstructionsEndChat"
                    rows="6"
                    class="bg-white text-black font-size-13"
                    placeholder="Type reply…"
                    :state="newInstructionsEndChat.length >= 20"
                >
                </b-form-textarea>

                <b-button v-show="!isUpdatingCloseInstructions && newInstructionsEndChat !== instructionsEndChat.instructions" variant="primary" class="mt-2 w-md" @click="updateCloseChatInstructions">Edit Close instructions</b-button>
                <vue-ellipse-progress
                    v-show="isUpdatingCloseInstructions"
                    :loading="isUpdatingCloseInstructions"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="50"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- Assistants -->
              <div v-for="assistant in assistants" :key="assistant.assistantId" class="rounded-4 bg-light p-3 mb-4">
                <h4>
                    {{ assistant.assistantName}}
                    <span class="badge bg-pink text-white ms-2 font-size-12">{{ assistant.model }}</span>
                </h4>
                <p>
                  <small class="text-muted">{{ assistant.assistantId }}</small>
                  <small class="text-dark ms-2">Instructions Id: <b>{{ assistant.instructionsId }}</b></small>
                  <small class="text-primary ms-2">Last update: <b>{{ formatDateString(assistant.updatedAt, 'DD MMM YYYY HH:mm') }}</b></small>
                </p>
                <hr/>
                <div class="rounded-4 bg-white p-2">
                  <span v-html="beautify(assistant.instructions)"></span>
                </div>

                <b-button variant="primary" class="mt-2 w-md" @click="updateAssistantUI(assistant)">Edit instructions</b-button>

              </div>

            </div>
          </div>
        </b-tab>

      </b-tabs>

    </div>

    <b-modal id="threads-modal" hide-footer>
      <template #modal-title>
        {{ $t("menuitems.system.ai_stats_title") }}
      </template>
      <ThreadAiView
          :threadArg="threadActive"
          v-on:UPDATE_THREAD_STATUS="updateThreadStatus"
          v-on:SHOW_MEDIA="showUserMedia"
      >
      </ThreadAiView>
    </b-modal>

    <b-modal id="assistant-update-modal" size="xl" hide-footer>
      <template #modal-title>
        {{ assistantObj.assistantName }} <small>{{ assistantObj.assistantId }}</small>
      </template>
      <div>
        <b-form-textarea
            v-model="newInstructions"
            rows="20"
            class="bg-white text-black font-size-13"
            placeholder="Type reply…"
            :state="newInstructions.length >= 20"
        >
        </b-form-textarea>
        <br>

        <div class="row d-flex justify-content-center">
          <vue-ellipse-progress
              v-show="isUpdatingAssistant"
              :loading="isUpdatingAssistant"
              :angle="-90"
              color="#50a5f1"
              emptyColor="#999"
              emptyColorFill="#f8f8fb"
              :size="50"
              :thickness="3"
              :emptyThickness="2"
              lineMode="out 2"
              animation="bounce 700 400"
              fontColor="#666"
              :half="false"
              class="mt-5 mb-5"
              fontSize="1rem">
          </vue-ellipse-progress>
        </div>

        <b-button v-show="!isUpdatingAssistant" class="ms-2" variant="success" @click="confirmUpdateAssistant()">
          Send Reply
        </b-button>
        <b-button v-show="!isUpdatingAssistant" class="ms-2" variant="danger" @click="cancelUpdateAssistant()">
          Cancel Updating
        </b-button>
      </div>
    </b-modal>

    <b-sidebar id="sidebar-right" right v-model="isUserPaneDisplayed">
      <vue-tabs
          v-model="userTabsActive"
          active-tab-color="#213213"
          active-text-color="white">
        <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
          <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
          <UserProfile
              :userId="null"
              :user="userTab"
              v-on:SHOW_MEDIA="showUserMedia">
          </UserProfile>
        </v-tab>
      </vue-tabs>
    </b-sidebar>

    <vue-simple-context-menu
        element-id="generatorContextMenu"
        :options="optionsContext"
        ref="generatorContextMenu"
        @option-clicked="processContextMenu"
    />

    <CoolLightBox
        :items="userMedia.media"
        :index="userMedia.index"
        :effect="'fade'"
        @close="userMedia.index = null">
    </CoolLightBox>

  </Layout>
</template>

<style>

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 60%;
  }
}

.b-sidebar-right {
  width:35%;
}

.b-sidebar-body {
  padding:16px;
}
</style>
